<section *ngIf="!mapOnly" class="w-100 h-100">
	<div *ngIf="toggled && showMinimize" class="jmCollapseTitleLearnMore">
		<div class="jmPageTitle" style="padding-top: 10px;">
			Location &amp; Contact
			<div (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square"></div>
		</div>
	</div>
	<div *ngIf="!toggled" class="h-100 jmWidgetPadding">
		<div class="w-100">
			<div class="jmPageTitle">
				Location &amp; Contact
				<div *ngIf="showMinimize" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square " style="right: 0px; margin-top:10px;"></div>
			</div>
		</div>
		<div style="height:75%;" class="row">
			<div [ngClass]="(lgView)?'col-4':'col-12'">
				<div style="font-size:1.2em; padding-bottom: 5px;">{{title}}</div>
				<div>{{subtitle}}</div>
			</div>
			<div [ngClass]="(lgView)?'col-8':'col-12'" class="jmGMapWrapper">
				<div id="gMap" class="jmGMap">
				</div>
			</div>
		</div>
		<div class="row" style="height:10%">
			<div class="col-12">&nbsp;</div>
		</div>
	</div>
</section>
<section *ngIf="mapOnly" class="w-100 h-100">
	<div class="jmGMapWrapper">
		<div id="gMap" class="jmGMap"></div>
	</div>
</section>
